import { defineComponent as _defineComponent } from 'vue'
import { Icons } from '@/font-awesome';
import CustomSelector from './CustomSelector.vue';
import { BranchAddresses } from '@/models/branch_addresses_model';
import { ref } from 'vue';
import CreateBranchModal from '../modals/CreateBranchModal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BranchSelector',
  props: {
    branches: { type: Object, required: true },
    zIndex: { type: Number, required: false },
    supportingText: { type: String, required: false }
  },
  emits: ["change", "set", "update:model-value", "create"],
  setup(__props: any, { expose: __expose }) {

const createBranchModal = ref<InstanceType<typeof CreateBranchModal>>();
const customSelector = ref<InstanceType<typeof CustomSelector>>();





__expose({
  setSelected: (value: number) => {
    customSelector.value?.setSelected(value);
  },
  clearSelection: () => {
    customSelector.value?.clearSelection();
  },
});


const __returned__ = { createBranchModal, customSelector, get Icons() { return Icons }, CustomSelector, CreateBranchModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})